import { render, staticRenderFns } from "./holidays.vue?vue&type=template&id=416bc968&scoped=true&"
import script from "./holidays.vue?vue&type=script&lang=js&"
export * from "./holidays.vue?vue&type=script&lang=js&"
import style0 from "./holidays.vue?vue&type=style&index=0&id=416bc968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416bc968",
  null
  
)

export default component.exports